module.exports = __webpack_public_path__ + "static/media/Mustang341_3c.d515aa5f.svg";